export const fuelConst = [
  {
    labels: [
      "Select Account Number",
      "Enter Transaction Reference",
      "Search",
      "Amount",
      "fuelType",
      "Station Name",
      "Car Plate number",
      "Commission",
      "Continue",
    ],
  },
  {
    // Amharic
    labels: [
      "የሂሳብ ቁጥር ይምረጡ",
      "የግብይት ማጣቀሻ አስገባ",
      "ፈልግ",
      "መጠን",
      "የነዳጅ አይነት",
      "የጣቢያ ስም",
      "የመኪና ሳጥን ቁጥር",
      "ኮሚሽን",
      "ቀጥል",
    ],
  },
  {
    // Oromo
    labels: [
      "Lakkoofsa Herregaa Filadhu",
      "Mallattoo Walqabsiistaa Galchaa",
      "Barbaadi",
      "Baay'ina",
      "Gosa Boba'a",
      "Maqaa Stayshinii",
      "Lakkoofsa Saanduqa Konkolaataa",
      "Komishinii",
      "Itti Fufi",
    ],
  },
  {
    // Tigrigna
    labels: [
      "ቁጽሪ ሕሳብ ምረጽ",
      "ዋዕላ ግብሪ ኣእትው",
      "ድለ",
      "ጠቕላላ ድምር",
      "ኣይነት ነዳዲ",
      "ስም ጣብያ",
      "ቁጽሪ ፕላት መኪና",
      "ኮሚሽን",
      "ቀጽል",
    ],
  },
  {
    // Somali
    labels: [
      "Xisaab Nambarka Dooro",
      "Tixraac Ganacsiga Geli",
      "Raadi",
      "Qadarka",
      "Nooca Saliida",
      "Magaca Saldhigga",
      "Lambarka Baaskiilka Gaariga",
      "Komishanka",
      "Sii Soco",
    ],
  },
  {
    // Afar
    labels: [
      "Hisab Nummara Yokale",
      "Gexsi Yameete",
      "Gexso",
      "Qadaana",
      "Nabada Yakme",
      "Station Yascasse",
      "Car Plate Nummara",
      "Komission",
      "Itteh",
    ],
  },
];
